
class GroupEditor {

  constructor(options) {
    this.options = options;

    // callbacks
    this.onChange = options.onChange || function(){};
    this.onSlotNumberChange = options.onSlotNumberChange || function(){};

    // properties
    this.elAccountsTable = options.elAccountsTable;
    this.elAddButton = options.elAddButton;
    this.elSubmitButton = options.elSubmitButton;
    this.elGroupName = options.elGroupName;
    this.signedInUser = options.signedInUser;

    this.hasExistingGroupNameError = false;

    this.elGroupName.addEventListener('change', ()=>this.validateGroupName());
    this.elAddButton.addEventListener('click', e=>this.addEmptySlot(e));

    this.buildInitialRows();
    this.ensureSomeoneIsAdmin();
    this.valuesUpdated();
  }

  get adminEmail() {
    return _.findWhere(this.accounts, {isAdmin: true}).value || null;
  }

  get slotCount() {
    return _.where(this.accounts, {checked: true}).length;
  }

  get totalCredit() {
    return this.accounts.reduce( (prev, account)=> prev + (account.checked ? account.credit : 0) , 0);
  }

  addEmptySlot() {
    const emptySlot = this.newGroupAccount({checked: true});
    this.accounts.push(emptySlot);
    this.elAccountsTable.appendChild( emptySlot.domElement() );
    emptySlot.editEmail();
    this.valuesUpdated();
    this.onSlotNumberChange();
  }

  buildInitialRows() {
    this.accounts = this.options.groupAccounts.map((accountDetails)=>{
      return this.newGroupAccount(accountDetails)
    })

    while( this.accounts.length < this.options.minSlots ) {
      // add empty slots until we reach min solts requirement
      this.accounts.push(this.newGroupAccount({checked: true}));
    }

    this.accounts.forEach((account)=>{
      this.elAccountsTable.appendChild( account.domElement() );
    })
  }

  newGroupAccount( accountDetails ) {
    const callbacks = {
      onChange: this.onAccountUpdate.bind(this),
      isEmailUnique: this.isEmailUnique.bind(this),
      signedInUser: this.signedInUser,
    }
    return new GroupAccount(Object.assign(callbacks, accountDetails));
  }

  onAccountUpdate(updatedAccount, source) {
    if( updatedAccount.isAdmin ) {
      // urgh radio button uglyness
      _.each(this.accounts, (account)=>{
        if( account != updatedAccount) {
          account.isAdmin = false;
        }
      });
    }

    this.valuesUpdated();
    this.onChange(updatedAccount, source);
  }

  valuesUpdated() {
    this.checkForErrors();
    this.saveGroupDesign();
  }
 
  // Error checking
  checkForErrors() {
    const hasAdminEmailError = this.hasAdminEmailError();
    const hasMinSlotsError = this.hasMinSlotsError();
    const hasExistingAdminsError = this.handleExistingAdminsError();

    FlashMessage.toggle(`You must select a licence with an email address to be admin`, hasAdminEmailError);

    FlashMessage.toggle(`You must select at least ${this.options.minSlots} licenses for a Business account. You can add an Unused License and add the email later.`, hasMinSlotsError);

    this.elGroupName.aibError.toggleError('Group name taken. Try another', this.hasExistingGroupNameError );

    this.elSubmitButton.disabled = ( this.hasExistingGroupNameError || hasExistingAdminsError || hasAdminEmailError || hasMinSlotsError);
  }

  hasMinSlotsError() {
    // true if the number of selected slots is less than min slots
    return this.slotCount < this.options.minSlots;
  }

  hasAdminEmailError() {
    // true if the selected admin slot has no email
    return !this.adminEmail
  }

  handleExistingAdminsError() {
    // checks if any of the accounts are already group admins. If so. Shows an error message & returns true

    const existingAdmins = _.pluck(_.where(this.accounts, {isGroupAdmin:true, checked:true}), 'email');

    FlashMessage.hide(this.adminErrorMsg); // hide previous error
    if( existingAdmins.length ) {
      this.adminErrorMsg = FlashMessage.show(`<strong>${existingAdmins}</strong> already administers a group and so can not be added to this one.`);
    }
    return !!existingAdmins.length
  }

  // API / Server calls
  saveGroupDesign() {
    // send group design to the server
    const groupDesign = {
      design_id: this.options.designId,
      group_name: this.elGroupName.value,
      group_admin: this.adminEmail,
      accounts: _.pluck(_.where(this.accounts, {checked: true}), 'value')
    }

    if( !_.isEqual(this.stashedDesign, groupDesign) ) {
      this.stashedDesign = groupDesign;

      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/group/group_editor_ws.php?action=save_group_design');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.responseType = 'json';
      xhr.onload = () => {
        if( xhr.response.error ) {
          FlashMessage.show(xhr.response.error);
        }
      };
      xhr.send(JSON.stringify(groupDesign));

    }
  }

  validateGroupName() {
    if( this.elGroupName.value ) {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', `https://api2.activeinboxhq.com/1.0/validate/group/name/${this.elGroupName.value}`);
      xhr.responseType = 'json';
      xhr.onload = () => {
        this.hasExistingGroupNameError = xhr.response.exists;
        this.checkForErrors();
      }
      xhr.send();
    }else {
      this.hasExistingGroupNameError = false;
      this.checkForErrors();
    }
  }

  // Helpers
  ensureSomeoneIsAdmin() {
    if( !this.adminEmail ){
      this.accounts[0].isAdmin = true;
    }
  }

  isEmailUnique(email, account) {
    // makes sure given email does not exist in this.accounts
    // ignoring 'account'
    return !_.find(this.accounts, (a)=> a !== account && a.email === email );
  }
}
